import { RECEIVE_COURSE_SECTIONS} from '../actions/course_actions';
  
  const CourseReducer = (state = { sections: undefined}, action) => {
    Object.freeze(state);
    let newState = Object.assign({}, state);
    switch(action.type) {
      case RECEIVE_COURSE_SECTIONS:
        newState.sections = action.sections.data;
        return newState;
      default:
        return state;
    }
  };
  
  export default CourseReducer;